/*
    Form for creating a new trip based on copying an existing one,
    split with media queries for different screen sizes

    There's an additional LaptopStopList component which is all
    about long lists of timepoints on landscape display
*/

import React from "react";
import Media from "react-media";

import MainContext from "../MainContext";

import TimeInput from "../Components/TimeInput";
import StyledCheckbox from "../Components/StyledCheckbox";
import DataItem from "../Components/DataItem";

import { getDestinations, getStopsForDestination } from "../Requests/BusOpsRequests";
import { getLanes } from "../Requests/UtilityRequests";
import { getTimePoints, addTrip, getNewRunNumber } from "../Requests/BusOpsRequests";

import { getTimeStringFromDate } from "../Scripts/Utilities";

export default class BusOpsAddTripForm extends React.Component {

    static contextType = MainContext;

    state = {
        route: "",
        run: 900,
        schedule: getTimeStringFromDate(new Date()),
        lanes: [],
        laneSelected: "",
        destinations: [],
        destinationSelected: "",
        timepoints: [],
        timepointsSelected: [],
        destChanged: false
    }

    //
    //
    submit = () => {
        // submit
        // close this entry
        // place alert

        const params = {...this.props.data, ...this.state};

        console.log("timepoints", this.state.timepointsSelected);

        const request = () => addTrip(params);
        const then = ({data}) => {

            console.log("ADD TRIP RETURN VALUE", data);

            // ...
            if(data){
                if(this.props.mode === "ALL" || this.props.mode === "NOT-DEPARTED"){
                    this.props.addTrip(data);
                }
                this.context.sendNotification(false, `New trip to ${this.state.destinationSelected} successfully added`);
            }
            else{
                this.context.sendNotification(true, "Failure to Add Trip, please try again");
            }
        };

        this.context.runProcessing(request, then, "addTrip");
    }

    //
    //
    updateValue = (evt) => {
        const dest = evt.target.name === "destinationSelected" ? evt.target.value : null;
        console.log("dest", dest);
        this.setState({[evt.target.name]:evt.target.value}, () => {
            if(dest){
                const params = {BusHeaderCode: dest, route: this.state.route, Direction: this.props.data.Direction};
                const request = () => getStopsForDestination(params);
                const then = ({data}) => {
                    console.log("DESTINATION TRIP DATA", data);
                    this.setState({timepoints: data, timepointsSelected: data, destChanged: true});
                };
                this.context.runProcessing(request, then, "getStopsForDestination");
            }
        });
    }

    //
    // select/deselect timepoints for the copy
    // 
    onCheckChanged = (stop) => {

        console.log("ON CHECKED CHANGED ADD TRIP", stop);

        let selected = null;

        if(this.state.timepointsSelected.includes(stop)){
            console.log("remove from list");
            selected = this.state.timepointsSelected.filter((v) => v !== stop);
        }
        else{
            console.log("add to list");
            selected = [...this.state.timepointsSelected, stop];
        }

        this.setState({timepointsSelected: selected});
    }

    //
    //
    componentDidMount(){
        // fill in the values for the state fields from the data prop
        // and run a request for the list of stops

        // const date = new Date(this.props.data.SchedDepTime);

        console.log("ADD TRIP FORM PROPS", this.props.data);

        this.setState({
            route: this.props.data.Route,
            // schedule: getTimeStringFromDate(date),
            laneSelected: this.props.data.SchedLaneGate,
            destinationSelected: this.props.data.HeaderCode
        });

        // lanes
        let request = () => getLanes({location: this.props.data.LocationId});
        let then = ({data}) => {
            const cleaned = data.map(v => v.laneGate);
            this.setState({lanes: cleaned});
        };
        this.context.runProcessing(request, then, "getLanes");
        
        // timepoints
        request = () => getTimePoints(this.props.data);
        then = ({data}) => {
            console.log("GET TIME POINTS", data);
            this.setState({timepoints: data, timepointsSelected: data});
        };
        this.context.runProcessing(request, then, "getTimePoints");

        // getDestinations
        request = () => getDestinations({route: this.props.data.Route});
        then = ({data}) => {
            console.log("DESTINATIONS", data);
            this.setState({destinations: data});
        };
        this.context.runProcessing(request, then, "getDestinations");

        // run number
        request = () => getNewRunNumber(this.props.data.TripNumber);
        then = ({data}) => {
            console.log("NEW RUN DATA", data);
            this.setState({run: data});
        };
        this.context.runProcessing(request, then, "getNewRunNumber");
    }

    render(){

        console.log("ADD TRIP STATE", this.state, this.state.headsign);
        console.log("ADD TRIP PROPS", this.props);

        return (
            <div className="vertical">
                <div className="busops-form">
                    <div style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-around"
                    }}>
                        <Media query="(max-width: 811px)">
                            <div style={{
                                display: "grid",
                                gridTemplateColumns: "1fr 1fr"
                            }}>
                                <div className="form-element-horizontal">
                                    <label>Route</label>
                                    <DataItem val={this.state.route} />
                                </div>
                                <div className="form-element-horizontal">
                                    <label>Run</label>
                                    <input className="short-input" type="text" value={this.state.run} name="run" onChange={this.updateValue} />
                                </div>
                                <div className="form-element-horizontal">
                                    <label>Dest</label>
                                    <DataItem val={this.state.destinationSelected} />
                                </div>
                                <div className="form-element-horizontal">
                                    Scheduled Departure
                                    <TimeInput 
                                        name="schedule"
                                        value={this.state.schedule} /* what's the default value here? */
                                        onChange={this.updateValue}
                                        nonMilitary={true}
                                    />
                                </div>
                            </div>
                        </Media>
                        <Media query="(min-width: 812px)">
                            <>
                            <div className="form-element-horizontal">
                                <label>Route</label>
                                    <DataItem val={this.state.route} />
                            </div>
                            <div className="form-element-horizontal">
                                <label>Run</label>
                                <input className="short-input" type="text" value={this.state.run} name="run" onChange={this.updateValue} />
                            </div>
                            <div className="form-element-horizontal">
                                <label>Dest</label>
                                <DataItem val={this.state.destinationSelected} />
                            </div>
                            <div className="form-element-horizontal">
                                Scheduled Departure
                                <TimeInput 
                                    name="schedule"
                                    value={this.state.schedule} /* what's the default value here? */
                                    onChange={this.updateValue}
                                    nonMilitary={true}
                                />
                            </div>
                            </>
                        </Media>
                        <div className="form-element-horizontal">
                            <label>Lane</label>
                            <select value={this.state.laneSelected} name="laneSelected" onChange={this.updateValue}>
                                {
                                    this.state.lanes.map((lane, index) => {
                                        return <option key={index} value={lane}>{lane}</option>
                                    })
                                }
                            </select>
                        </div>
                        <div className="form-element-horizontal-full">
                            <label>Destination</label>
                            <select value={this.state.destinationSelected} name="destinationSelected" onChange={this.updateValue}>
                                {
                                    this.state.destinations.map((dest, index) => {
                                        return <option key={index} value={dest.BusHeaderCode}>{dest.DestinationName}</option>
                                    })
                                }
                            </select>
                        </div>
                    </div>

                    <div style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-around",
                        height: "100%"
                    }}>
                        <div className="form-element-vertical">
                            <Media query="(max-width: 811px)">
                                <>
                                <div style={{
                                    marginBottom: "4px",
                                    fontWeight: "bold",
                                    backgroundColor: "white",
                                    alignSelf: "stretch",
                                    textAlign: "center"
                                }}>STOP LIST</div>
                                <div className="stoplist">
                                {
                                    this.state.timepoints.map((stop, index) => {
                                        return (
                                            <div key={index}>
                                                <StyledCheckbox 
                                                    name="stops"
                                                    label={stop.Description.toLowerCase()}
                                                    checked={this.state.timepointsSelected.includes(stop)}
                                                    onChange={() => this.onCheckChanged(stop)}
                                                />
                                            </div>
                                        );
                                    })
                                }
                                </div>
                                </>
                            </Media>
                            <Media query="(min-width: 812px)">
                                {
                                    /*
                                        separate component, defined below, for the sake of code clarity
                                    */
                                }
                                <LaptopStopList 
                                    label={"STOP LIST"}
                                    stops={this.state.timepoints} 
                                    selected={this.state.timepointsSelected} 
                                    onChange={this.onCheckChanged} />
                            </Media>
                        </div>
                    </div>
                </div>
                
                <div className="option  " onClick={this.submit}>Add Trip</div>
            </div>
        )
    }
}

//
// for the laptop view, we'll try to limit the vertical space
// by splitting a long list of timepoints into either 2 or 3 groups,
// and then displaying those as pages
//
// the split will be based on the overall list size and we make sure to 
// have consistent spacing on the last page by using filler blank elements
//
class LaptopStopList extends React.Component {

    state = {
        currentPage: 1
    }

    goForward = () => {
        this.setState({currentPage: this.state.currentPage+1});
    }

    goBackward = () => {
        this.setState({currentPage: this.state.currentPage-1});
    }

    render() {

        // based on size of this.props.stops
        // if < 10, just use group 1
        // if > 10, <= 20, split in two
        // if > 20, <= 30, split in three

        // find the splitting points...s

        let group1 = [];
        let group2 = [];
        let group3 = [];

        let className = "stoplist";

        if(this.props.stops.length <= 10){
            group1 = this.props.stops;
            className = "stoplist-single";
        }
        else if(this.props.stops.length <= 20){
            group1 = this.props.stops.slice(0, 10 /*this.props.stops.length/2*/);
            group2 = this.props.stops.slice(10 /*this.props.stops.length/2+1*/, this.props.stops.length-1);
        }
        else{
            group1 = this.props.stops.slice(0, 10 /*this.props.stops.length/3*/);
            group2 = this.props.stops.slice(10 /*this.props.stops.length/3+1*/, 20 /*2*this.props.stops.length/3*/);
            group3 = this.props.stops.slice(20 /*2*this.props.stops.length/3+1*/, 30 /*this.props.stops.length-1*/);
        }

        return (
            <>
            <div style={{
                marginBottom: "4px",
                fontWeight: "bold",
                backgroundColor: "white",
                alignSelf: "stretch",
                textAlign: "center",
                width: "50vw",

                display: "flex",
                justifyContent: "center"
            }}>
                {
                    this.state.currentPage === 2
                    ? <span className="paging" onClick={this.goBackward}><i className="fas fa-long-arrow-alt-left"></i></span>
                    : null
                }
                <span style={{margin:"auto 4px"}}>
                    {this.props.label}
                </span>
                {
                    this.state.currentPage === 1 && this.props.stops.length > 20
                    ? <span className="paging" onClick={this.goForward}><i className="fas fa-long-arrow-alt-right"></i></span>
                    : ""
                }
            </div>
            <div className={className} style={{width: "50vw"}}>
            {
                this.state.currentPage === 1
                ? <div>
                {
                    group1.map((stop, index) => {
                        return (
                                <div key={index}>
                                    <StyledCheckbox 
                                        name="stops"
                                        label={stop.Description.toLowerCase()}
                                        checked={this.props.selected.includes(stop)}
                                        onChange={() => this.props.onChange(stop)}
                                    />
                                </div>
                            );
                    })
                }
                </div>
                : null
            }
            {
                group2.length > 0 
                ? <div>
                {
                    group2.map((stop, index) => {
                        return (
                                <div key={index}>
                                    <StyledCheckbox 
                                        name="stops"
                                        label={stop.Description.toLowerCase()}
                                        checked={this.props.selected.includes(stop)}
                                        onChange={() => this.props.onChange(stop)}
                                    />
                                </div>
                            );
                    })
                }
                </div>
                : null
            }
            {
                this.state.currentPage === 2
                ? <div>
                {
                    group3.map((stop, index) => {
                        return (
                                <div key={index}>
                                    <StyledCheckbox 
                                        name="stops"
                                        label={stop.Description.toLowerCase()}
                                        checked={this.props.selected.includes(stop)}
                                        onChange={() => this.props.onChange(stop)}
                                    />
                                </div>
                            );
                    })
                }
                </div>
                : null
            }
            </div>
            </>
        )
    }
}